import { makeStyles } from '@material-ui/core';
import OxqLogoCompact from './logo/oxq-logo-compact.svg';


const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
  },
  path: {
    fill: '#7df3e1',
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  return (
    <img 
    src={OxqLogoCompact}
    alt="Oxq Logo Compact"
    className={classes.svg}
    data-testid="logo-icon"
    />
  );
};

export default LogoIcon;
